module.exports = __webpack_public_path__ + "static/media/ChickenSans-ExtraLight.0817a61f.woff2";